import React from 'react';
import ProjectHighlightsDesign from './ProjectHighlightsDesign';
import Footer from '../../common/Footer';

const DesignProjects = () => {
  return (
    <section className=''>
      <ProjectHighlightsDesign />
      <Footer/>
    </section>
  );
};

export default DesignProjects;
